import { render, staticRenderFns } from "./ChatInfoSkeleton.vue?vue&type=template&id=2ca8c53d&scoped=true"
import script from "./ChatInfoSkeleton.vue?vue&type=script&lang=js"
export * from "./ChatInfoSkeleton.vue?vue&type=script&lang=js"
import style0 from "./ChatInfoSkeleton.vue?vue&type=style&index=0&id=2ca8c53d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ca8c53d",
  null
  
)

export default component.exports